module.exports = __webpack_public_path__ + "static/media/signUpAddTeamButton.36bd2cb3.svg";